export { default } from './imageSlice';
